import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { GoogleGeocoding } from 'app/shared/models/google.results.models';
import { GoogleMapFunctions } from '../../shared/utilities/googleAddress';

@Component({
  selector: 'address-map',
  templateUrl: './address-map.component.html',
  styleUrls: ['./address-map.component.css']
})
export class AddressMapComponent implements OnInit, OnChanges {
  @Input() address: MapAddressInput = new MapAddressInput();
  @Output('update') addressChange = new EventEmitter<MapAddressInput>();

  map = new GoogleMapFunctions(this.http);
  noAddress = false;
  showSearch = false;
  addressSearchString = '';
  searchResults = [];
  integration;

  constructor(private http:HttpClient) { }

  mapStyle = [
    {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "weight": "2.00"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#9c9c9c"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#ad7223"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e5e4e4"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#6b6767"
            },
            {
                "weight": "0.68"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#f6f6f6"
            },
            {
                "weight": "3.00"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#cecece"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#7b7b7b"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#3470c9"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#1f539f"
            },
            {
                "visibility": "on"
            },
            {
                "saturation": "-30"
            },
            {
                "lightness": "30"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    }
]
  ngOnInit(): void {
    this.integration = localStorage.getItem('integration').toLowerCase();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if(!!changes.address && !!changes.address.currentValue) this.newAddress( this.address )
  }

  newAddress(a:MapAddressInput){
    //   if((!a.lat || !a.long) && !!a.address && !!a.zipCode) this.getGoogleCoords(a);
    if(!a.address && !a.zipCode) this.noAddress = true;
  }

  test(e){
    //console.log(e)
  }

  getGoogleCoords(a) {
      this.address.lat = 55.6699359;
      this.address.long = 12.5859493;
      if(!!a.address && a.zipCode){
          this.map.geoCodeSearch(a.address + ', ' + a.zipCode,'da').subscribe(
              (data: GoogleGeocoding)=> {
                  if(!!data && !!data.results && data.status == 'OK') this.changeCoords(data);
                } 
          )
      }
  }

  searchAddress(){
    //   if(!!this.addressSearchString && this.addressSearchString.length > 3){
    //       this.map.geoCodeSearch(this.addressSearchString,'da').subscribe(
    //           (data: GoogleGeocoding)=>{
    //             console.log(data)
    //               if(!!data && data.status == 'OK'){
    //                   this.searchResults = data.results.map(x => { return x.formatted_address.split(',') });
    //               }
    //               console.log(data.results.map(x => { return x.formatted_address.split(',') }))
    //           }
    //       )
    //   }
    if(!!this.addressSearchString && this.addressSearchString.length > 3) {
        this.http.get<any[]>('https://dawa.aws.dk/adresser/autocomplete?q=' + this.addressSearchString ).subscribe(
                {
                    next:(data:any)=> {
                        if(!!data && data.length > 0){
                            if(data.length == 1) {
                                let add = data[0].adresse;
                                let vej = add.vejnavn;
                                if (add.husnr) { vej = vej + ' ' + add.husnr; }
                                if (add.etage) { vej = vej + ', ' + add.etage + '.'; }
                                if (add.dør) { vej = vej + ' ' + add.dør + '.'; }
                                this.address = {
                                    name: this.address.name,
                                    address: vej,
                                    zipCode: add.postnr,
                                    city: add.postnrnavn,
                                    lat: add.y,
                                    long: add.x
                                }
                                this.noAddress = false;
                                this.addressChange.emit(this.address);
                            }
                            this.searchResults = data.length > 1 ? data : [];
    
                        }
                        else {
                            this.searchResults = [];
                        }
                    }
                }
            )
    }
    else this.searchResults = [];
  }

  selectAddress(a:any){
    this.address.zipCode = a.adresse.postnr;
    this.address.city = a.adresse.postnrnavn;
    this.address.address = a.tekst.replace(', '+ a.adresse.postnr + ' ' + a.adresse.postnrnavn, ''  );
    this.address.lat = a.adresse.y;
    this.address.long = a.adresse.x;
    this.searchResults = [];
    this.noAddress = false;
    this.addressChange.emit(this.address);
  }

  changeCoords(data:GoogleGeocoding){
    let result = this.map.extractLatLongFromGeocoding(data);
    this.address = {...this.address, lat: result.lat, long:result.long};
    this.addressChange.emit(this.address);
  }

}

export class MapAddressInput {
  lat:number = 55.6699359;
  long: number = 12.5859493;
  name: string = '';
  address: string = '';
  zipCode: string = '';
  city: string = '';
}